import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Linkedin2: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? '20'}
      height={size ?? '20'}
      fill={color ? color : 'none'}
      viewBox="0 0 20 20"
      data-testid="linkedin-icon"
    >
      <path
        fill={color ?? '#fff'}
        d="M4.014 6.122a1.685 1.685 0 100-3.37 1.685 1.685 0 000 3.37zM7.29 7.4v9.35h2.903v-4.624c0-1.22.23-2.402 1.743-2.402 1.492 0 1.51 1.396 1.51 2.48v4.547h2.905v-5.128c0-2.519-.542-4.455-3.486-4.455-1.414 0-2.361.776-2.749 1.51h-.039V7.4H7.29zm-4.731 0h2.908v9.35H2.559V7.4z"
      />
    </svg>
  );
};

export default Linkedin2;
